import React from 'react';
import { Table } from '@devexpress/dx-react-grid-bootstrap4';
import ClickableTableCell from '../tables/shared/ClickableTableCell';
import { A } from 'hookrouter';

// Alignment =  start | center | right
const Cell = ({ children, anilgnment }) => {
    return (
        <Table.Cell>
            <div className={`h-100 d-flex align-items-center justify-content-${anilgnment ?? 'left'}`}>
                {children}
            </div>
        </Table.Cell>
    );
}

const TableLink = ({ linkText, href }) => {
    return (
        <A
            className='btn btn-link text-left border-0 d-flex align-items-center '
            href={href}
        >
            {linkText}
        </A>
    );
}

const ExlComponent = ({ row, column, type, ...restProps }) => {

    const columnName = column.name;
    let href = row.email ? `/exlTeacherDetails/${row.id}` : `/exlCourseDetails/${row.id}`;

    if (columnName === "name") {
        return (
            <Cell anilgnment="start">
                <TableLink href={href} linkText={row[columnName]} />
            </Cell>
        );
    }

    if (columnName === 'teacherName' && !!row[columnName]) {

        const firstTwoteachers = row[columnName]?.slice(0, 2);
        const teachersOverflow = row[columnName]?.slice(2);

        return (
            <>
                <Cell>
                    {firstTwoteachers && firstTwoteachers.map((teacher, index) => (
                        <TableLink
                            key={teacher.id}
                            linkText={teacher.name}
                            href={`exlTeacherDetails/${teacher.id}`}
                        />
                    ))}
                    {teachersOverflow && teachersOverflow.length > 0 && (
                        <div
                            style={{ fontSize: "11px", lineHeight: "initial", background: "#dae0e5" }}
                            className="d-flex gap-1 p-1 m-2 align-items-center justify-content-center rounded"
                        >
                            <div>+</div>
                            <div>{teachersOverflow.length}</div>
                        </div>

                    )}
                </Cell>
            </>
        )
    }

    if (columnName === 'numCourses' || columnName === 'numBookings') {
        return (
            <Cell anilgnment="end">
                {row[columnName]}
            </Cell>
        )
    }

    return (
        <Cell>
            {row[columnName]}
        </Cell>
    );

};

export default ExlComponent;
